import adjustmentReducer from './adjustment'
import purchaseOrderReducer from './purchaseOrder'
import summaryReducer from './summary'
import supplierReducer from './supplier'
import transferReducer from './transfer'
import ingredientSubscriptionReducer from './ingredientSubscription'

export {
  adjustmentReducer,
  purchaseOrderReducer,
  summaryReducer,
  supplierReducer,
  transferReducer,
  ingredientSubscriptionReducer
}



// WEBPACK FOOTER //
// ./app/reducers/inventory/index.js